import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SearchView from '../views/SearchView.vue'
import SearchVin from '../views/SearchVin.vue'

import AuctionView from '../views/AuctionView.vue'
import Iframe from '../views/Iframe.vue'



const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/iframe',
    name: 'iframe',
    component: Iframe
  },
  {
    path: '/search',
    name: 'search',
    props: true,
    component: SearchView
  },
  {
    path: '/search_vin',
    name: 'search_vin',
    props: true,
    component: SearchVin
  },
  {
     path: "/auction/:id",
     name:"auction", 
     component: AuctionView 
    },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
